import { createUseStyles } from 'react-jss'
import { black } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  title: {
    fontSize: 20,
    color: black,
    marginTop: 16
  },
  closeIcon: {
    position: 'absolute',
    top: 10,
    right: 10,
    padding: 10,
    width: 32,
    height: 32,
    cursor: 'pointer'
  },
  content: {
    marginTop: 16
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'center',
    columnGap: 8,
    marginTop: 28
  }
})

export default useStyles
